module.exports = __webpack_public_path__ + "img/ltku-4x.fe51155.jpg";